import { useFormikContext } from 'formik'
import { SourcePicker } from 'components/Wizards/CampaignWizard/SourcePicker'

export const ReferenceText = () => {
  const { values, setFieldValue } = useFormikContext<{ [key: string]: any }>()

  return (
    <SourcePicker
      value={{
        importer: values.reference_type,
        value: values.reference_text,
        doc: values.reference_doc,
        filename: values.reference_filename,
      }}
      onChange={({ importer, value, doc, filename }) => {
        setFieldValue('reference_type', importer)
        setFieldValue('reference_text', value)
        setFieldValue('reference_doc', doc)
        setFieldValue('reference_filename', filename)
      }}
    />
  )
}
